var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlane64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "32px",
    viewBox: "0 0 40 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plane / 64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SAF---Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.15, 1.4)",
    fill: "#111111",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1185434,10 L18.033826,0 L12.2372391,0 L17.3897608,10 M33.3020361,10 L9.01691302,10 L5.9028577,4.96375 C5.43719855,4.210625 4.59862564,3.75 3.69371401,3.75 L0,3.75 L3.8643913,18.75 L18.1826051,18.75 L12.2372391,30 L18.033826,30 L25.9113877,18.75 L33.4913912,18.75 C36.02772,18.75 38.0745593,16.718125 37.9979155,14.240625 C37.923848,11.845625 35.770738,10 33.3020361,10 Z M14.1694348,14.375 L16.1016304,14.375 M19.9660217,14.375 L21.8982173,14.375 M25.7626086,14.375 L27.6948043,14.375",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlane64);
export default __webpack_public_path__ + "static/media/Icon_Plane_64.934e190e59c4a8be3deb9304ffccbca0.svg";
export { ForwardRef as ReactComponent };